/**
 * calculateAge — a member's age in whole years, from their date of birth.
 *
 * **It lives here, with no dependencies, because `Utils.js` imports `axios`.**
 * That import is ESM-only and Jest cannot transform it, so every module that
 * reaches this function through `Utils.js` drags an untransformable dependency
 * into its own test's module graph — and a pure date calculation had become
 * untestable for a reason that has nothing to do with dates.
 *
 * `Utils.js` re-exports it, so every existing caller is unchanged and there is
 * still one implementation.
 *
 * Kept verbatim, including its epoch-delta arithmetic: it is what the
 * generator sends to the backend today, and the analysis is ruled to be
 * personalised the same way generation is. Changing how an age is computed
 * would change what the two flows agree on, which is a different decision from
 * where the function lives.
 *
 * @param {string|Date} dateOfBirth
 * @returns {number} whole years
 */
export const calculateAge = (dateOfBirth) => {
  const dob = new Date(dateOfBirth);
  const diffMs = Date.now() - dob.getTime();
  const ageDt = new Date(diffMs);
  return Math.abs(ageDt.getUTCFullYear() - 1970);
};

export default calculateAge;
